import { Injectable } from '@angular/core';
import { API_ENDPOINT } from '@core/configs';
import { CreateTemplateDTO, DeleteTemplateDTO } from '@core/models/dto/template.dto';
import { ApiService } from '../common/api.service';

@Injectable({
  providedIn: 'root',
})
export class TemplateService {
  constructor(private readonly http: ApiService) {
  }

  getAll() {
    return this.http.get(
      API_ENDPOINT.template.controller + API_ENDPOINT.template.getAll,
    );
  }

  getTemplateDetail(id: number) {
    return this.http.get(
      API_ENDPOINT.template.controller + API_ENDPOINT.template.getDetail + id,
    );
  }

  createTemplate(data: CreateTemplateDTO) {
    return this.http.post(
      API_ENDPOINT.template.controller,
      data,
    );
  }

  updateTemplate(data: CreateTemplateDTO, id: number) {
    return this.http.put(
      API_ENDPOINT.template.controller + id,
      data,
    );
  }

  deleteTemplate(data: DeleteTemplateDTO) {
    return this.http.put(
      API_ENDPOINT.template.controller + API_ENDPOINT.template.deleteTemplate,
      data,
    );
  }
}
